/**
 * @author      Shivani Mehra
 * @date        Sep, 2024
 * @copyright   www.ibirdsservices.com
 */

import React, { useEffect, useState } from "react";
import { Button, Col, Container, Card, Row, Table } from "react-bootstrap";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import { ToastContainer, toast } from "react-toastify"; // npm i react-toastify --force
import "react-toastify/dist/ReactToastify.css";
import CreateSettings from "./CreateSettings";
import jwt_decode from "jwt-decode";
import { ShimmerTable } from "../common/ShimmerTable";
import { FaTrash, FaEdit, FaPlus } from "react-icons/fa";
const AllWhatsappSettings = () => {
  const [body, setBody] = useState([]);
  const [isSpinner, setIsSpinner] = useState(false);
  const [modalShowHide, setModalShowHide] = useState(false);
  const [rowData, setRowData] = useState();
  const [userInfo, setUserInfo] = useState(
    jwt_decode(sessionStorage.getItem("token")),
  );

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await WhatsAppAPI.getAllWhatsAppSettingRecord();
      if (response.success) {
        setBody(response.record);
      } else {
        setBody([]);
      }
    } catch (error) {
      console.error("Error fetching campaign data:", error);
      setBody([]);
    } finally {
      setIsSpinner(true);
    }
  };

  // Create table headers consisting of 4 columns.
  const labels = { beforeSelect: " " };
  const header = [
    { title: "Name", prop: "name", isFilterable: true },
    { title: "App ID", prop: "app_id" },
    { title: "Phone number ID", prop: "business_number_id" },
    {
      title: "WhatsApp Business Account ID",
      prop: "whatsapp_business_account_id",
    },
    { title: "End Point Url", prop: "end_point_url" },
    { title: "Phone", prop: "phone", isFilterable: true },
  ];

  const editRecord = (data) => {
    setModalShowHide(true);
    setRowData(data?.row);
  };

  const createRecord = () => {
    setModalShowHide(true);
    setRowData();
  };

  const onRefreshData = () => {
    // toast.success('Record updated successfully.');
    setModalShowHide(false);
    fetchData();
  };

  return (
    <>
      <Container className="mt-5">
        <Row className="mx-5 mb-4">
          <Card className="p-4 header-bg shadow-sm border-0 rounded-3">
            <h5 className="mb-2 fw-bold">💡 Quick Guide</h5>
            <small>
              Configure your WhatsApp settings carefully to ensure smooth
              integration. Keep your credentials and webhook URLs updated for
              reliable message delivery.
            </small>
          </Card>
        </Row>

        <Row className="mx-5 g-0">
          <Col lg={12} className="mb-3">
            <Row className="g-0">
              <Col lg={12}>
                <div className="bg-white shadow-sm border-0 rounded-3 p-4">
                  <h5 className="fw-semibold mb-1">📦 All Settings</h5>

                  {isSpinner ? (
                    <DatatableWrapper
                      body={body}
                      headers={header}
                      paginationOptionsProps={{
                        initialState: {
                          rowsPerPage: 10,
                          options: [5, 10, 15, 20],
                        },
                      }}
                    >
                      <Row className="mb-3">
                        <Col
                          lg={3}
                          sm={10}
                          xs={10}
                          className="d-flex flex-col justify-content-end align-items-end"
                        >
                          <Filter className="p-2" />
                        </Col>
                        <Col
                          lg={4}
                          sm={2}
                          xs={2}
                          className="d-flex flex-col justify-content-start align-items-start"
                        >
                          <PaginationOptions labels={labels} />
                        </Col>
                        <Col
                          lg={5}
                          sm={12}
                          xs={12}
                          className="mt-2 d-flex flex-col justify-content-end align-items-end"
                        >
                          <Button
                            className="btn btn-sm"
                            variant="outline-secondary"
                            onClick={() => createRecord()}
                          >
                            <FaPlus /> Add New Setting
                          </Button>
                        </Col>
                      </Row>

                      <div className="table-responsive">
                        <Table
                          striped
                          bordered
                          className="related-list-table"
                          responsive="sm"
                        >
                          <TableHeader />
                          <TableBody />
                        </Table>
                      </div>
                      <Pagination />
                    </DatatableWrapper>
                  ) : (
                    <ShimmerTable row={10} col={4} />
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      {modalShowHide && (
        <CreateSettings
          show={modalShowHide}
          onHide={() => {
            setModalShowHide(false);
          }}
          onRefreshData={onRefreshData}
          rowData={rowData}
          table="whatsAppSetting"
        />
      )}

      <ToastContainer autoClose={30000} />
    </>
  );
};

export default AllWhatsappSettings;
